import ContactForm from '../components/forms/ContactForm';
import SEO from '../components/SEO';

const ContactPage = () => {
  return (
    <div>
      <SEO
        title="Contact Us - Get in Touch with Kommonview"
        description="Contact Kommonview for cloud infrastructure, DevOps, IT services, and digital solutions. Email us at support@kommonview.com or use our contact form. We're ready to help transform your business."
        keywords="contact kommonview, get in touch, IT support, cloud consulting, technology services contact, South Africa IT company"
        url="https://kommonview.com/contact"
      />

      {/* Hero Section */}
      <section className="bg-primary text-white py-20">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-heading font-bold mb-6" data-aos="slide-right">
              Invitation
            </h1>
            <p className="text-xl text-gray-100" data-aos="slide-left" data-aos-delay="100">
              The house of kommonview can't wait to be of service to you.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
